<div class="title-description-form">
  @if (isEditing) {
    <form [formGroup]="formGroup">
      <div class="static-label-input write-title">
        <textarea type="text"
                  formControlName="title"
                  class="no-border-input w-100 name-input"
                  #titleInput
                  rows="1"
                  [appAutoResizeInput]="entityId"
                  [class.no-border-input]="titleInput !== document.activeElement"
                  (keydown.enter)="onEnter($event)"
                  (input)="onTitleInput($event)"
                  (focus)="onTitleFocus()"
                  (blur)="onTitleBlur()"
                  id="titleInput"
                  [placeholder]="'TITLE_DESC.NAME_PLACEHOLDER' | translate"></textarea>
      </div>
      <div class="floating-label-textarea">
        <textarea id="descriptionField"
                  class="no-border-input w-100 description-input"
                  #textAreaElement
                  rows="1"
                  [appAutoResizeInput]="fields?.description"
                  [defaultHeight]="'22'"
                  formControlName="description"
                  (focus)="onDescriptionFocus()"
                  (blur)="onDescriptionBlur()"
                  [class.no-border-input]="textAreaElement !== document.activeElement"
                  [placeholder]="'TITLE_DESC.DESCRIPTION_PLACEHOLDER' | translate"></textarea>
      </div>
    </form>
  } @else {
    @if (fields?.title) {
      <div class="form-group read-title-wrapper">
        <span class="read-title">{{ fields!.title }}</span>
      </div>
    }
    @if (fields?.description) {
      <div class="form-group">
        @if (isMarkdownEnabled) {
          <span class="read-description markdown" [innerHTML]="description"></span>
        } @else {
          <span class="read-description">{{ fields!.description }}</span>
        }
      </div>
    }
  }
</div>
